<template>
    <div class="psychology">
        <a-avatar :size="111" icon="user" :src="avatarUrl" />
        <p style="margin: 16px 0px 9px 0px;font-size: 18px;font-weight: bold;">{{ $store.state.user.info.realname }}</p>
        <p style="font-size: 13px;color: #000;margin-bottom: 15px;">{{ departName.schoolName }}</p>
        <div class="psychologyInfoBox">
            <span style="display: inline-block;width: 90px;">预约时间：</span>
            <a-date-picker style="width:calc(100% - 90px);min-width: 190px" showTime valueFormat="YYYY-MM-DD HH:mm:ss"
                v-model="info.appoTime" placeholder="请输入预约时间"></a-date-picker>
        </div>
        <div class="psychologyInfoBox">
            <span style="display: inline-block;width: 90px;">联系方式：</span> <a-input placeholder="请输入联系方式"
                style="width: calc(100% - 90px);" v-model="info.phone" />
        </div>
        <div class="psychologyInfoBox" style="flex-direction: column;align-items: flex-start;">
            咨询问题： <a-textarea placeholder="请输入要咨询的问题" :rows="6" style="width: 100%;" v-model="info.comment" />
        </div>
        <a-row type="flex" justify="center" :gutter="[0, 17]" align="middle" style="margin-top: 20px;">
            <a-col :span="24">
                <div class="buttonBox" @click="sumbitFn">提交</div>
            </a-col>
            <a-col :span="24">
                <div class="buttonBox" @click="deleteFn">取消预约</div>
            </a-col>
        </a-row>
        <p style="font-size: 12px;color: #303030;padding-top: 20px;">注：在心理老师回应前可取消心理咨询预约</p>
    </div>
</template>

<script>
import { postAction, getAction, deleteAction } from '@/api/manage'
import Vue from "vue";
import { SYSTEM_INFO } from "@/store/mutation-types";
export default {
    name: 'psychology',
    components: {},
    data() {
        return {
            info: {}
        }
    },
    computed: {
        avatarUrl() {
            if (this.$store.state.user.avatar) {
                return this.$store.state.user.avatar
            } else if (this.$store.state.user.info && this.$store.state.user.info.avatar) {
                return this.$store.state.user.info.avatar
            } else {
                return "/img/avatar.png"
            }
        },
        departName() {
            return Vue.ls.get(SYSTEM_INFO)
        }
    },
    created() {
        this.init()
    },
    mounted() { },
    methods: {
        init() {
            getAction('/teaching/teachingAppointment/getMyLastAppo?appointmentType=4').then(res => {
                console.log(res, 'res')
                if (res.success) {
                    this.info = res.result || {}
                }
            })
        },
        sumbitFn() {
            if (!this.info.appoTime) {
                this.$message.error('请选择预约时间')
                return
            }
            if (!this.info.phone) {
                this.$message.error('请输入联系方式')
                return
            }
            if (this.info.phone.length != 11) {
                this.$message.error('请输入正确的联系方式')
                return
            }
            if (!this.info.comment) {
                this.$message.error('请输入要咨询的内容')
                return
            }
            postAction('/teaching/teachingAppointment/appo', { phone: this.info.phone, appoTime: this.info.appoTime, comment: this.info.comment, appointmentType: 4 }).then(res => {
                if (res.success) {
                    this.$message.success('预约成功!')
                    this.$router.back()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        deleteFn() {
            let _this = this
            this.$confirm({
                title: '提示',
                content: '此操作将取消健康咨询，是否确认？',
                okText: '确认',
                okType: 'No',
                cancelText: '取消',
                onOk() {
                    deleteAction('/teaching/teachingAppointment/delMyAppo?id=' + _this.info.id).then(res => {
                        if (res.success) {
                            _this.$message.success('成功取消!')
                            _this.init()
                        }
                    })
                },
                onCancel() {
                    console.log('Cancel');
                },
            });

        }
    }
}
</script>

<style lang='scss' scoped>
.psychology {
    width: 100%;
    min-height: calc(100vh - 50px);
    max-width: 1200px;
    margin: 0 auto;
    padding: 27px 30px;
    display: flex;
    align-items: center;
    // justify-content: center;
    flex-direction: column;

    .psychologyInfoBox {
        margin-top: 11px;
        padding: 8px 25px;
        width: 100%;
        border-radius: 15px;
        min-height: 30px;
        background: rgba(32, 32, 32, 0.12);
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
        font-size: 15px;
        color: #000;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .buttonBox {
        width: 180px;
        height: auto;
        padding: 4px 18px;
        color: #fff;
        font-weight: bold;
        font-size: 17px;
        background: #68ADCA;
        border-radius: 9px;
        text-align: center;
        margin: 0 auto;
    }
}
</style>
